import { IProExam } from "../pro-exam/pro-exam.models";
import { GetApplicationsReq, MarkAttendanceReq, ProApplicationReview, ProUserApplication, RefereeStep } from "./applications.model";

export class ApplicationsAction {
  static readonly type = '[Applications] Add item';
  constructor(public payload: string) { }
}

export class GetApplications {
  static readonly type = '[Applications] Get applications';
  constructor(public payload: GetApplicationsReq) { }
}

export class GetMMIApplications {
  static readonly type = '[Applications] Get MMI applications';
  constructor(public payload: GetApplicationsReq) { }
}

export class GetPhase2Applications {
  static readonly type = '[Applications] Get Phase 2 applications';
  constructor(public payload: string) { }
}

export class ClearApplications {
  static readonly type = '[Applications] Clear applications';
}

export class GetMMIInterviewees {
  static readonly type = '[Applications] Get MMI interviewees';
  constructor(public payload: string) { }
}

export class AssignApplicationsToCohort {
  static readonly type = '[Applications] Assign applications to cohort';
  constructor(public payload: { cohortId: string, applicationIds: string[] }) { }
}

export class UpdateAttendance {
  static readonly type = '[Applications] Update attendance';
  constructor(public payload: MarkAttendanceReq) { }
}

export class MarkAttendance {
  static readonly type = '[Applications] Mark attendance';
  constructor(public payload: MarkAttendanceReq) { }
}

export class GetProApplications {
  static readonly type = '[Applications] Get Pro applications';
  constructor() { }
}

// User Application Actions
export class SaveStep {
  static readonly type = '[Applications] Save Phase 1 Step';
  constructor(public payload: { step: string, data: any, isFinished?: boolean }) { }
}

export class SavePhaseTwoStep {
  static readonly type = '[Applications] Save Phase 2 Step';
  constructor(public payload: { step: string, data: any, isFinished?: boolean }) { }
}

export class SubmitApplication {
  static readonly type = '[Applications] Submit application';
  constructor(public payload: string) { }
}
export class SubmitPro2Application {
  static readonly type = '[Applications] Submit Pro 2 application';
  constructor(public payload: { application: ProUserApplication, currentExam: IProExam | null }) { }
}

export class DeleteReferees {
  static readonly type = '[Applications] Delete Referees';
  constructor(public payload: { applicationIds: string[], applicationType: string }) { }
}
export class UpdateSinglePhaseTwoStep {
  static readonly type = '[Applications] Update Single Phase 2 Step';
  constructor(public payload: { step: string, data: any, isFinished?: boolean }) { }
}

export class SaveSinglePhaseTwoStep {
  static readonly type = '[Applications] Save Single Phase 2 Step';
  constructor(public payload: { step: string, data: any, isFinished?: boolean }) { }
}

export class GetSingleStepApplication {
  static readonly type = '[Applications] Get Single Step Application';
  constructor(public payload: { applicationNo: string, step: string }) { }
}

export class InitiateApplication {
  static readonly type = '[Applications] Initiate application';
  constructor(public payload: { examId: string; language?: 'en' | 'fr' }) { }
}

/**
 * Stores the applicant's chosen language before the application is created.
 * Dispatched from the BeginningPageComponent so that InitiateApplication
 * (fired later in personal-information) can forward the value to the backend.
 *
 * Enregistre la langue choisie avant la création de la demande.
 */
export class SetPendingApplicationLanguage {
  static readonly type = '[Applications] Set Pending Application Language';
  constructor(public payload: 'en' | 'fr') { }
}

export class SaveApplicationLanguage {
  static readonly type = '[Applications] Save Application Language';
  constructor(public payload: { id: string; language: 'en' | 'fr'; phase: 'phase1' | 'phase2' }) { }
}

export class OpenPhase2Application {
  static readonly type = '[Applications] Open Phase 2 application';
  constructor(public payload: {
    "id": string,
    "applicationNo": string,
    "examId": string,
  }) { }
}

export class CopyApplication {
  static readonly type = '[Applications] Copy application';
  constructor(public payload: { userId: string, fromExamId: string, toExamId: string }) { }
}

export class UnSubmitApplication {
  static readonly type = '[Applications] Unsubmit application';
  constructor(public payload: string) { }
}


export class UnSubmitPhase2Application{
  static readonly type = '[Applications] Unsubmit Phase 2 application';
  constructor(public payload: string) { }
}

export class SelectProApplication {
  static readonly type = '[Applications] Select Pro application';
  constructor(public payload: ProUserApplication | null) { }
}

export class SelectProReviewApplication {
  static readonly type = '[Applications] Select Pro review application';
  constructor(public payload: ProApplicationReview) { }
}

export class ClearSelectedProApplication {
  static readonly type = '[Applications] Clear selected Pro application';
  constructor() { }
}

export class MarkInReviewApplication {
  static readonly type = '[Applications] Mark In Review application';
  constructor(public payload: string) { }
}

export class SaveFlag {
  static readonly type = '[Applications] Save Application Flag';
  constructor(public payload: { applicationNo: string, message: string, author: string }) { }
}

export class GetFlags {
  static readonly type = '[Applications] Get  Application Flags';
  constructor(public payload: string) { }
}

export class SaveAdminStep {
  static readonly type = '[Applications] Save Admin Step';
  constructor(public payload: { step: string, appNo: string, data: any }) { }
}

export class SavePhase2AdminStep {
  static readonly type = '[Applications] Save Phase 2 Admin Step';
  constructor(public payload: { step: string, appNo: string, data: any }) { }
}

export class SetApplicationDecision {
  static readonly type = '[Applications] Set Application Decision';
  constructor(public payload: {
     applicationNo: string, 
     examId: string, 
     decision: string, 
     referralReasons?: string[], 
     conditions?: string[], 
     ineligibleCriterias?: string[],
     comment?: string, 
     reasons?: string[]
     }) { }
}

export class SetNeedClinicalDirector {
  static readonly type = '[Applications] Set Need Clinical Director Review';
  constructor(public payload: { needClinicalDirectorReview: boolean, examId: string }) { }
}

export class GetAdminData {
  static readonly type = '[Applications] Get Admin Data';
  constructor(public payload: { applicationNo: string, examId: string }) { }
}

export class GetApplicationRecord {
  static readonly type = '[Applications] Get Application Record';
  constructor(public payload: { applicationNo: string, step: string }) { }
}

export class GetPhase2ApplicationRecord {
  static readonly type = '[Applications] Get Phase 2 Application Record';
  constructor(public payload: { applicationNo: string, step: string }) { }
}

export class GetFlagDetails {
  static readonly type = '[Applications] Get Flag Details';
  constructor(public payload: string) { }
}

export class GetEligibilityDetails {
  static readonly type = '[Applications] Get Eligibility Details';
  constructor(public payload: string) { }
}

/** Loads the review audit trail of an application for the review-count dialog.
 *  Charge la piste d'audit des révisions pour le dialogue de décompte. */
export class GetReviewHistory {
  static readonly type = '[Applications] Get Review History';
  constructor(public payload: { applicationNo: string, phase?: 1 | 2 }) { }
}

/** Loads the candidate's earlier applications for the previous-applications dialog.
 *  Charge les candidatures antérieures du candidat. */
export class GetPreviousApplications {
  static readonly type = '[Applications] Get Previous Applications';
  constructor(public payload: { userId: string, examId: string }) { }
}
export class UpdateFlagResolution {
  static readonly type = '[Applications] Update Flag Resolution';
  constructor(public payload: string, public flags: { id: string, isResolved: boolean }[]) { }
}

export class GetAllProExamApplications {
  static readonly type = '[Applications] Get All PRO Exams Applications';
  constructor(public payload: { examId: string, status?: string, portalDrawId?: string, phase2PortalDrawId?: string, decisionMade?: string, stealth?: boolean }) { }
}

export class GetAllProExamApplicationsSilent {
  static readonly type = '[Applications] Get All PRO Exams Applications Silent';
  constructor(public payload: { examId: string, status?: string, portalDrawId?: string, phase2PortalDrawId?: string, decisionMade?: string }) { }
}


export class GetExportedApplications {
  static readonly type = '[Applications] Get Exported Applications';
  constructor(public payload: { examId: string }) { }
}


export class GetAllApplicationSteps {
  static readonly type = '[Applications] Get All Application Steps';
  constructor(public payload: string) { }
}

export class ClearAllApplicationSteps {
  static readonly type = '[Applications] Clear All Application Steps';
  constructor() { }
}

export class AddReferenceNote {
  static readonly type = '[Applications] Add Reference Note';
  constructor(public payload: { step: string, data: any }) { }
}

export class ResendSingleReferenceEmail {
  static readonly type = '[Applications] Resend Single Reference Email';
  constructor(public payload: { step: string, applicationNo: string, email: string }) { }
}

export class ResendSingleRotationEquivalences {
  static readonly type = '[Applications] Resend Single Rotation Equivalences Email';
  constructor(public payload: { applicationNo: string, refereeId: string }) { }
}

export class ResendReferenceEmail {
  static readonly type = '[Applications] Resend Reference Email';
  constructor(public payload: { step: string, applicationNo: string }) { }
}

/** Applicant resends the reference request email to one of their own referees
 *  from the phase-2 application preview. */
export class ResendApplicantRefereeEmail {
  static readonly type = '[Applications] Resend Applicant Referee Email';
  constructor(public payload: { applicationNo: string, step: RefereeStep, refereeId: string }) { }
}

/** Loads every referee of an application for the referees-status dialog.
 *  Charge tous les répondants d'une candidature pour la boîte de dialogue. */
export class GetApplicationReferees {
  static readonly type = '[Applications] Get Application Referees';
  constructor(public payload: { applicationNo: string }) { }
}

/** Admin resends the reference request email to one referee of an application.
 *  Relance administrateur d'un répondant d'une candidature. */
export class AdminResendRefereeEmail {
  static readonly type = '[Applications] Admin Resend Referee Email';
  constructor(public payload: { applicationNo: string, step: RefereeStep, refereeId: string }) { }
}

export class GetReferencesByApplicationId {
  static readonly type = '[Applications] Get References By Application Id';
  constructor(public payload: { step: string, applicationId: string }) { }
}

export class GetAdminApplicationByNo {
  static readonly type = '[Applications] Get Admin Application By No';
  constructor(public payload: { applicationNo: string }) { }
}
